<script setup>
  import { useLayoutStore } from '@/stores/layout';
  import { resetAllStores } from '@/utils/store';
  import { router } from '@inertiajs/vue3';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const layout = useLayoutStore();
  const { logoutDialog } = storeToRefs(layout);

  const loading = ref(false);

  /**
   * The sequence of clearing Pinia stores is important,
   * otherwise the local storage will be populated with Pinia stores again (with default/initial values)
   */
  function clearPiniaStores() {
    // Reset all registered Pinia stores
    resetAllStores();

    // Clear local storage (ALL, not only for Pinia local storage stores)
    localStorage.clear();
  }

  function cancelLogoutHandler() {
    layout.closeLogoutDialog();
  }

  function confirmLogoutHandler() {
    layout.closeLogoutDialog();
    loading.value = true;

    router.post(
      '/logout',
      {},
      {
        onSuccess: () => {
          clearPiniaStores();
        },
        onFinish: () => {
          // Will be called after onSuccess() or onError()
          loading.value = false;
        },
      }
    );
  }
</script>

<template>
  <v-dialog v-model="logoutDialog" max-width="450">
    <v-card class="pa-4">
      <v-card-title class="text-h6 text-pre-wrap">{{
        t('confirmations.logoutCaption')
      }}</v-card-title>
      <v-card-text>{{ t('confirmations.logoutText') }}</v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          @click="cancelLogoutHandler"
          variant="outlined"
          color="grey-darken-4"
          class="mr-4 px-4"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="confirmLogoutHandler"
          :loading="loading"
          variant="elevated"
          color="error"
          class="px-4"
          >Logout</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
